import { Injectable } from '@angular/core';
import { Division } from 'assets/constants/enums';
import { fetchAuthSession, fetchUserAttributes } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { EncryptedLocalStorageService } from '../storage';
import { AuthErrorService } from '../auth-error/auth-error.service';
import { NavigationService } from '../navigation';
import { AuthenticationService } from '../auth';
import { GlobalStateService } from '../state/global-state';
@Injectable({
	providedIn: 'root',
})
export class AuthHubService {
	constructor(
		private readonly storage: EncryptedLocalStorageService,
		private readonly authErrorService: AuthErrorService,
		private readonly navigationService: NavigationService,
		private readonly authService: AuthenticationService,
		private readonly globalStateService: GlobalStateService,
	) {}

	configureAuthListener = () => {
		Hub.listen('auth', async (data) => {
			switch (data.payload.event) {
				case 'signedIn': {
					const attributes = await fetchUserAttributes();
					const user = {
						email: attributes.email,
						firstname: attributes['given_name'],
						lastname: attributes['family_name'],
						_id: attributes['custom:mongo_id'],
						audaraId: attributes['custom:audara_id'],
						branch: attributes['custom:branch'],
						roles: attributes['custom:role'] ? attributes['custom:role'].split(',') : [],
						defaultDivision: attributes['custom:default_division'] || Division.All,
						defaultAccount: attributes['custom:default_account'],
						status: attributes['custom:status'],
					};
					this.authService.storeUserAttributes(user, this.storage);

					const session = await fetchAuthSession();
					const expirationTimestamp = session.tokens.accessToken.payload.exp * 1000;
					this.authService.storeAuth(session.tokens.accessToken.toString(), expirationTimestamp);
					this.authService.storeUser(user as any);
					this.authService.startTokenMonitor();

					await this.globalStateService.initState(false);

					this.navigationService.navigatePost('/dashboard');

					break;
				}
				case 'tokenRefresh_failure': {
					this.authService.stopTokenMonitor();
					this.storage.clear();

					this.authErrorService.setError('Your session has expired.');

					this.navigationService.navigatePost('/login');
					break;
				}
				case 'signInWithRedirect_failure': {
					if (data.payload.data.error.message.toLowerCase() === 'user cancelled oauth flow.') {
						break;
					}

					this.authErrorService.setError('We’re sorry, but there was an issue signing in with your Google account.');

					this.navigationService.navigatePost('/login');
					break;
				}
			}
		});
	};
}
